import { PaymentCard, paymentCardSchema } from './schema'

/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access,
   @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return --
   TODO: Properly type API response before Zod parsing */
export class BookingStoredCardsServiceFetch {
  async readAll(): Promise<PaymentCard[]> {
    const results: any = await $fetch('/_/fallback/_/users/stored-cards/')
    return this.mappedCards(results.cards)
  }

  private mappedCards(cards): PaymentCard[] {
    return cards.map((card) => {
      return paymentCardSchema.parse({
        brand: card.brand,
        expMonth: card.exp_month.toString(),
        expYear: card.exp_year.toString(),
        id: card.id.toString(),
        last4: card.last4.toString(),
        canDelete: card.can_delete,
      })
    })
  }
}
